module.exports = __webpack_public_path__ + "static/img/switchActive.a637a89e.png";